// Mirrors backend compute_level / compute_badge (social.py) + reward titles.

export function computeLevel(stats = {}) {
  const matches = stats.matches || 0;
  const wins = stats.wins || 0;
  return 1 + Math.floor(Math.sqrt(matches + wins * 2));
}

export function levelProgress(stats = {}) {
  const matches = stats.matches || 0;
  const wins = stats.wins || 0;
  const xp = matches + wins * 2;
  const level = 1 + Math.floor(Math.sqrt(xp));
  const curFloor = (level - 1) * (level - 1); // xp needed for current level
  const nextFloor = level * level;            // xp needed for next level
  const into = xp - curFloor;
  const span = nextFloor - curFloor;
  return { level, xp, into, span, pct: Math.min(100, Math.round((into / span) * 100)), toNext: nextFloor - xp };
}

const BADGES = [
  [50000, "Diamond"],
  [20000, "Gold"],
  [5000, "Silver"],
  [-Infinity, "Bronze"],
];

export function computeBadge(stats = {}) {
  const tp = stats.total_profit || 0;
  for (const [th, name] of BADGES) if (tp >= th) return name;
  return "Bronze";
}

const TITLES = [
  [1, "Rookie"],
  [2, "Trader"],
  [3, "Analyst"],
  [4, "Strategist"],
  [5, "Shark"],
  [6, "Whale"],
  [8, "Legend"],
];

export function titleForLevel(level) {
  let name = "Rookie";
  for (const [min, n] of TITLES) if (level >= min) name = n;
  return name;
}

export function allTitles() {
  return TITLES.map(([min, name]) => ({ min, name }));
}

export const BADGE_STYLES = {
  Diamond: "text-cyan-300 border-cyan-300/50 bg-cyan-300/5",
  Gold: "text-signal border-signal/50 bg-signal/5",
  Silver: "text-white/70 border-white/30 bg-white/5",
  Bronze: "text-orange-400 border-orange-400/50 bg-orange-400/5",
};

export const BADGE_RING = {
  Diamond: "ring-2 ring-cyan-300/70 shadow-[0_0_20px_rgba(103,232,249,0.35)]",
  Gold: "ring-2 ring-signal/70 shadow-[0_0_20px_rgba(234,179,8,0.35)]",
  Silver: "ring-2 ring-white/40",
  Bronze: "ring-2 ring-orange-400/50",
};
